module.exports = {"350424100":"翠江镇","350424101":"泉上镇","350424102":"湖村镇","350424103":"石壁镇","350424104":"曹坊镇","350424105":"安远镇","350424106":"淮土镇","350424107":"安乐镇","350424108":"水茜镇","350424200":"城郊乡","350424201":"城南乡","350424202":"济村乡","350424204":"方田乡","350424207":"治平畲族乡","350424208":"中沙乡","350424209":"河龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350424.json
// module id = 1190
// module chunks = 0